import { QueryClient } from '@tanstack/react-query';

import { isDjangoErrorResponse } from 'api/common';
import type { BackendErrorResponse } from 'api/types';

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: BackendErrorResponse;
  }
}

// Playwright and friends set `navigator.webdriver`; real browsers don't. e2e can't opt out
// of retries at build time — CI serves the very artifact it deploys — and retrying makes
// every test of a failure state wait out the 1s/2s/4s backoff.
const isAutomatedBrowser = typeof navigator !== 'undefined' && navigator.webdriver;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      retryOnMount: false,
      retry: (failureCount, error) => {
        if (isDjangoErrorResponse(error) && error.code === 'approve_required') {
          return false;
        }

        if (import.meta.env.DEV || isAutomatedBrowser) {
          return false;
        }

        return failureCount < 3;
      },
    },
  },
});
